import React from 'react'

import { API } from 'services';

import { AbstractContainer } from 'containers';

import { DeviceScene } from 'scenes';

import axios from 'axios';

class DeviceContainer extends AbstractContainer {

  getTasks(params) {

    let device = params.device;

    return [
      {
        key: 'device',
        exec: (done, failure) => {
          API.get(`devices/${device}`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'sensors',
        exec: (done, failure) => {
          API.get(`sensors`)
            .then((response) => {
              done(response.data);
            })
            .catch(failure);
        }
      },
      {
        key: 'appstore',
        exec: (done, failure) => {
          // fetch('https://itunes.apple.com/lookup?bundleId=com.lim-group.equisym&country=fr',
          // { method: 'GET',
          // mode: 'cors',
          // cache: 'default' })
          // .then(response => response.json())
          //   .then((data) => {
          //     done(data);
          //   })
          //   .catch(failure);
          done({results:[{version:"1.4.2"}]})
        }
      }
    ]
  }

  getComponent(results) {
    return <DeviceScene device={results.device} firmwares={results.firmwares} sensors={results.sensors} appStoreVersion={results.appstore.results[0].version} />
  }
}

export default DeviceContainer;
